import { getFetchRequest, GET_CURRENT_USER } from '../store/requests';
import { makeUrl } from '../const/const';

class UserService {
    constructor() {
        this.currentUser = null;
        this.observers = [];
        this.isLoaded = false;
        
        // Автоматически начинаем загрузку если есть токен
        if (localStorage.getItem('token')) {
            this.getCurrentUser().catch(error => {
                console.error('❌ [UserService] Auto-load failed:', error);
            });
        }
    }

    // Подписка на изменения информации о пользователе
    subscribe(observer) {
        this.observers.push(observer);
        // Если информация уже загружена, уведомляем подписчика
        if (this.isLoaded) {
            observer(this.currentUser);
        }
    }

    // Отписка от изменений
    unsubscribe(observer) {
        this.observers = this.observers.filter(obs => obs !== observer);
    }

    // Уведомление подписчиков об изменениях
    notify() {
        this.observers.forEach(observer => observer(this.currentUser));
    }

    // Получить информацию о текущем пользователе
    async getCurrentUser() {
        return new Promise((resolve, reject) => {
            const url = makeUrl([GET_CURRENT_USER]);
            
            getFetchRequest(
                url,
                (userInfo) => {
                    console.log('👤 [UserService] User info loaded:', userInfo);
                    this.currentUser = userInfo;
                    try {
                        localStorage.setItem(
                            'elsi_price_currency',
                            userInfo && userInfo.priceCurrency === 'USD' ? 'USD' : 'RUB',
                        );
                    } catch (e) {
                        console.warn('Failed to store price currency', e);
                    }
                    this.isLoaded = true;
                    this.notify();
                    resolve(userInfo);
                },
                (error) => {
                    console.error('❌ [UserService] Error loading user info:', error);
                    this.currentUser = null;
                    this.isLoaded = true;
                    this.notify();
                    reject(error);
                },
            );
        });
    }

    // Проверить может ли пользователь делать заказы
    canMakeOrders() {
        if (!this.currentUser) {
            console.log('👤 [UserService] No user info available');
            return false;
        }

        const canMakeOrders = this.currentUser.can_make_orders === true;
        console.log('👤 [UserService] Can make orders:', {
            can_make_orders: this.currentUser.can_make_orders,
            status: this.currentUser.status,
            access_level: this.currentUser.access_level,
            result: canMakeOrders,
        });

        return canMakeOrders;
    }

    // Получить статус пользователя
    getUserStatus() {
        if (!this.currentUser) {
            return null;
        }

        return {
            status: this.currentUser.status,
            access_level: this.currentUser.access_level,
            can_make_orders: this.currentUser.can_make_orders,
            needs_validation: this.currentUser.needs_validation,
            message: this.currentUser.message,
        };
    }

    // Принудительно обновить информацию о пользователе
    async refreshUser() {
        console.log('👤 [UserService] Refreshing user info...');
        return await this.getCurrentUser();
    }
}

// Создаем единственный экземпляр сервиса
export const userService = new UserService();

// Добавляем в глобальную область для shared компонентов
window.userService = userService;

console.log('👤 [UserService] Service initialized and added to window');